/**
 * Query key factory for the caller's feature-flag states.
 *
 * Deliberately degenerate: the server returns every flag resolved for every
 * org the caller belongs to, so the org is a lookup *into* the cached value
 * rather than part of the key. One cache entry serves the whole session, which
 * is what lets the boot prefetch, `useCheckFeatureFlag`, and the flag-gated
 * route loaders all share a single fetch.
 *
 * Because the key carries no identity, `AuthProvider` must drop this entry on
 * sign-in and sign-out — otherwise a second session in the same tab would read
 * the previous user's flags.
 *
 * @see https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories
 */
export const featureFlagQueryKeys = {
  states: () => ["featureFlagStates"] as const,
};
